enum MastersRoutes {
  Masters = '/masters',
}

export default MastersRoutes;
